import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PageBreadcrumbComponent } from '../../../shared/components/common/page-breadcrumb/page-breadcrumb.component';
import { ContactStateApiService } from '../services/contact-state-api.service';
import { ContactStateResponse } from '../models/contact-state.model';
import { AuthService } from '../../auth-pages/services/auth.service';
import { ConfirmDialogService } from '../../../shared/services/confirm-dialog.service';
import { ToastService } from '../../../shared/services/toast.service';
import { HasPermissionDirective } from '../../../shared/directives/has-permission.directive';

@Component({
  selector: 'app-contact-state-list',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    PageBreadcrumbComponent,
    HasPermissionDirective
  ],
  templateUrl: './contact-state-list.component.html'
})
export class ContactStateListComponent implements OnInit {
  estados: ContactStateResponse[] = [];
  loading = false;
  error = '';

  constructor(
    private stateApi: ContactStateApiService,
    private authService: AuthService,
    private router: Router,
    private confirmDialog: ConfirmDialogService,
    private toast: ToastService
  ) { }

  ngOnInit(): void {
    this.cargarEstados();
  }

  cargarEstados(): void {
    this.loading = true;
    this.error = '';

    const user = this.authService.getCurrentUser();
    const businessId = user?.businessId || 1;

    this.stateApi.getStates(businessId).subscribe({
      next: (data) => {
        this.estados = data;
        this.loading = false;
      },
      error: (err) => {
        this.error = err.error?.message || 'Error al cargar los estados de contacto';
        this.loading = false;
        console.error('Error:', err);
      }
    });
  }

  nuevoEstado(): void {
    this.router.navigate(['/config-contactos/estados/crear']);
  }

  editarEstado(estado: ContactStateResponse): void {
    this.router.navigate(['/config-contactos/estados/editar', estado.id]);
  }

  async eliminarEstado(estado: ContactStateResponse): Promise<void> {
    const ok = await this.confirmDialog.confirmDanger({
      title: 'Eliminar estado',
      message: `¿Está seguro de eliminar el estado "${estado.name}"?`
    });
    if (!ok) return;
    const user = this.authService.getCurrentUser();
    const businessId = user?.businessId || 1;

    this.stateApi.deleteState(estado.id, businessId).subscribe({
      next: () => {
        this.cargarEstados();
        this.toast.deleted('Estado de contacto', `Se eliminó "${estado.name}" correctamente.`);
      },
      error: (err) => {
        this.toast.error({ title: 'Error', message: err.error?.message || 'Error al eliminar el estado' });
      }
    });
  }
}
